export const smoothScrollTo = (target) => {
    target.scrollIntoView({behavior: "smooth", block: "start"});
}

export const copyToClipboard = (str) => {
    const el = document.createElement('textarea')
    el.value = str
    el.setAttribute('readonly', '')
    el.style.position = 'absolute'
    el.style.left = '-9999px'
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
}

export const isScrolledIntoView = (element, callback) => {
    if (!element || !callback) return;

    const observer = new window.IntersectionObserver(([entry]) => {
        callback(entry);
    }, { threshold: 0.5 })

    observer.observe(element)
}

export const boolToInt = (value) => +value;

export const isMobile = () => window.matchMedia("(max-width: 575px)").matches;